import { useEffect, useState } from 'react';
import './App.css';
import UseCurrentPage from './helpers/PageRoutingFuncs';
//components
import Header from './components/Header';
import HomePage from './Pages/HomePage/HomePage';
import Footer from './components/Footer';
import MobileMenu from './components/MobileMenu';
import TripsPage from "./Pages/TripsPage/TripsPage";
import LoginPage from './Pages/LoginPage/LoginPage';
import ExplorePage from './Pages/ExplorePage/ExplorePage';
import UserAccountPage from "./Pages/UserAccountPage/UserAccountPage";
import CheckoutPage from './Pages/CheckoutPage/CheckoutPage';
import DealsPage from "./Pages/DealsPage/DealsPage";
import HelpPage from "./Pages/HelpPage/HelpPage";
import HPSupport from "./components/HPSupport";
import { ToastContainer } from "react-toastify";
import CurrenciesPane from './components/CurrenciesPane';
import LanguagesPane from './components/LanguagesPane';
import "react-toastify/dist/ReactToastify.css";
import CONSTANTS from './Constants/Constants';
import { toast } from 'react-toastify';
import MiniInfoWindow from './components/MiniInfoWindow';

let CURR=CONSTANTS.default_currency;
if (localStorage.getItem(CONSTANTS.local_storage.wellgo_usr_curr)) {
    CURR = localStorage.getItem(CONSTANTS.local_storage.wellgo_usr_curr);
} else {
    localStorage.setItem(CONSTANTS.local_storage.wellgo_usr_curr, CURR);
}

let LANG=CONSTANTS.default_language[0]+CONSTANTS.default_language.toLowerCase().substring(1);
if (localStorage.getItem(CONSTANTS.local_storage.wellgo_usr_lang)) {
    LANG = localStorage.getItem(CONSTANTS.local_storage.wellgo_usr_lang);
} else {
    localStorage.setItem(CONSTANTS.local_storage.wellgo_usr_lang, LANG);
}
let AMLOGGEDIN=false;
if(localStorage.getItem(CONSTANTS.local_storage.logged_in_usr)){
  AMLOGGEDIN=JSON.parse(localStorage.getItem(CONSTANTS.local_storage.logged_in_usr));
}else{
  localStorage.setItem(CONSTANTS.local_storage.logged_in_usr, AMLOGGEDIN);
}

// Function to always return the current flight search object from local-storage
window._getSearchObj=()=>{
  return JSON.parse(localStorage.getItem(CONSTANTS.local_storage.flight_search_object));
}

// Instantiating search post obj
global.instantiateSearchObj();

function App() {

  const PRODUCT_TYPE = localStorage.getItem(CONSTANTS.local_storage.product_type) || CONSTANTS.product_types.flights;

  const [ showSearchPage, setShowSearchPage ] = useState(false);
  const [ showSearchPageForm, setShowSearchPageForm ] = useState(true);
  const [ checkoutRawData, setCheckoutRawData ] = useState({});
  const [ checkoutDataProvider, setCheckoutDataProvider ] = useState("");
  const [ isCheckout, setIsCheckout ] = useState(false);
  const [ isLoggedIn, setIsLoggedIn ] = useState(AMLOGGEDIN);
  const [ checkoutPayload, setcheckoutPayload ] = useState({});
  const [ showHomePageSearchForm, setShowHomePageSearchForm ] = useState(false);
  const [ toggleShowCurrencyPage, setToggleShowCurrencyPage ] = useState(false);
  const [ siteCurrency, setSiteCurrency ] = useState(CURR);
  const [ toggleShowLanguagesPage, setToggleShowLanguagesPage ] = useState(false);
  const [ siteLanguage, setSiteLanguage ] = useState(LANG);
  const [ paymentIntent, setPaymentIntent ] = useState();
  const [ bookingIntent, setBookingIntent ] = useState();
  const [ productType, setProductType ] = useState(PRODUCT_TYPE);
  const [ agentDetails, setAgentDetails ] = useState(null);
  const [ BESettings, setBESettings ] = useState({showHeader: false});
  const [ hasNewMessageFromParent, setHasNewMessageFromParent ] = useState(false);
  const [ currentParentMessge, setCurrentParentMessge ] = useState({})
  const [ showPartsWithAgentDetails, setShowPartsWithAgentDetails ] = useState(false);

  useEffect(()=>{
    UseCurrentPage();
    window.addEventListener("message", function(event) {
      const messageBody = JSON.parse(event?.data);
      if(messageBody?.from_welldugo_oc){

        setHasNewMessageFromParent(true);
        setCurrentParentMessge(messageBody);
        let _s_key="";
        let _prompt_usr_msg = "";
        if(messageBody?.type==="engine-parameters"){
          _s_key="engine_parameters";
          _prompt_usr_msg="Booking Engine Parameters Changed";
        }else if(messageBody?.type==="book-itinerary-item"){
          _s_key="book_itinerary_item";
          const {
            package_id,
          } = messageBody?.postBody?.item;
          if(package_id){
            localStorage.setItem("package_id", package_id);
          }
          _prompt_usr_msg="Booking for Itinerary Started";
        }else if(messageBody?.type==="verify-search-link"){
          _s_key="verify_search_link";
          _prompt_usr_msg="Starting Search Link Verification";
        }
        if(_s_key)
          localStorage.setItem(_s_key, event?.data);
        toast(_prompt_usr_msg);
        if(messageBody?.type==="verify-search-link"){
          setTimeout(() => {
            window.location.href=messageBody?.postBody?.item?.link;
          }, 5000);
        }
        console.log(event);
      }
    });
    if(localStorage.getItem("book_itinerary_item") && !currentParentMessge?.from_welldugo_oc && currentParentMessge?.type!=="engine-parameters"){
      const _exst_msg = localStorage.getItem("engine_parameters")
      const _engine_parameters_info = JSON.parse(_exst_msg);
      const _msg_to_send = {
        from_welldugo_agent_app: true,
        type: "engine-parameters",
        postBody: _engine_parameters_info?.postBody
      }
      window.parent.postMessage(JSON.stringify(_msg_to_send), "*");
    }
    if(localStorage.getItem("book_itinerary_item") && !currentParentMessge?.from_welldugo_oc && currentParentMessge?.type!=="book-itinerary-item"){
      const _exst_msg = localStorage.getItem("book_itinerary_item")
      const _book_itinerary_item_info = JSON.parse(_exst_msg);
      setCurrentParentMessge(_book_itinerary_item_info);
    }

    const params = new URLSearchParams(window.location.search);
    if(
        params.has("booking_id") &&
        params.has("cust_eml")
    ){
      if(
        params.has('product') && 
        parseInt(params.get('product')) === CONSTANTS?.product_types?.flights
      ){
        setIsCheckout(true);
      }
    }
    
 },  []);

 /*useEffect(()=>{
  if(agentDetails){
    alert("here")
  }
 }, [agentDetails]);*/

  window.__setAgentDetails = (info_obj) => {
    setAgentDetails(info_obj);
  }
  window.__setBESettings = (settings_ob) => {
    setBESettings(settings_ob);
  }

  const show_search_page = () => {
    cancel_checkout();
    setShowSearchPage(true);
  }
  // making show_search_page() global
  window.__show_search_page__=show_search_page;

  const show_home_page = (with_search_form=false) => {
    cancel_checkout();
    setShowSearchPage(false);
    setShowHomePageSearchForm(with_search_form);
  }
  // making show_home_page() global
  window.__show_home_page__=show_home_page;

  const cancel_checkout = () => {

    // Ask before leaving checkout page
    if(CONSTANTS.checkout_pages.app_level_checkout_status===true) {
      let userResponse = window.confirm("Do you want to exit the checkout page?");
      if (userResponse) {
        //console.log("User clicked OK");
        // Reset app level checkout status
        CONSTANTS.checkout_pages.app_level_checkout_status=false;
      } else {
        //console.log("User clicked Cancel");
        return;
      }
    }

    setIsCheckout(false);
    setcheckoutPayload({});

  }

  const change_product_type = (type=0, call_back=()=>{}) => {
    setProductType(type);
    localStorage.setItem(CONSTANTS.local_storage.product_type, type);
    call_back();
  }
  // Making above function global
  window.__change_proct_type=change_product_type;
  const get_current_product_type = () => {
    return productType;
  }
  // Making above function global
  window.__get_current_product_type=get_current_product_type;

  const begin_checkout = (data, rawData, data_provider) => {
    
    setCheckoutDataProvider(data_provider);
    setCheckoutRawData(rawData);
    setcheckoutPayload(data);
    setIsCheckout(true);

    // Constant App Level Checkout Status
    CONSTANTS.checkout_pages.app_level_checkout_status=true;
  }

  const toggle_show_hide_currency_page = () => {
    setToggleShowCurrencyPage(!toggleShowCurrencyPage);
  }

  const toggle_show_hide_languages_page = () => {
    setToggleShowLanguagesPage(!toggleShowLanguagesPage);
  }

  const SelectSiteCurrency = (CURR) => {
    setSiteCurrency(CURR);
    localStorage.setItem(CONSTANTS.local_storage.wellgo_usr_curr, CURR);
  }

  const SelectSiteLanguage = (LANG) => {
    setSiteLanguage(LANG);
    localStorage.setItem(CONSTANTS.local_storage.wellgo_usr_lang, LANG);
  }

  const LogMeIn = () => {
    setIsLoggedIn(true);
    localStorage.setItem(CONSTANTS.local_storage.logged_in_usr, true);
  }

  const LogMeOut = () => {
    setIsLoggedIn(false);
    localStorage.setItem(CONSTANTS.local_storage.logged_in_usr, false);
    localStorage.removeItem("user_token");
  }

  let MiniInforPromptData={};
  let PopupTitle="";
  let PopupMsgSource = "";
  let PopupCloseFunction = null;
  let PopupActionFunction = null;
  let PopupActionButtonTitle = "";
  if(
    hasNewMessageFromParent &&
    currentParentMessge?.from_welldugo_oc &&
    currentParentMessge?.type==="book-itinerary-item"
  ){
    MiniInforPromptData = currentParentMessge?.postBody;
    PopupTitle="Book Itinerary Item";
    PopupMsgSource="Operational Center";
    PopupActionFunction = () => {
      if(window.confirm("Are you sure, you want to cancel itinerary booking?")){
        setCurrentParentMessge({});
        setHasNewMessageFromParent(false);
        if(localStorage.getItem("book_itinerary_item")){
          localStorage.removeItem("book_itinerary_item");
        }
        window.location.reload();
      }
    }
    PopupActionButtonTitle = "Cancel Itinerary Booking";
  }else if(localStorage.getItem("book_itinerary_item")){
    let __obj = JSON.parse(localStorage.getItem("book_itinerary_item"));
    MiniInforPromptData = __obj?.postBody;
    PopupTitle="Book Itinerary Item";
    PopupMsgSource="Operational Center";
    PopupActionFunction = () => {
      if(window.confirm("Are you sure, you want to cancel itinerary booking?")){
        if(localStorage.getItem("book_itinerary_item")){
          localStorage.removeItem("book_itinerary_item");
        }
        window.location.reload();
      }
    }
    PopupActionButtonTitle = "Cancel Itinerary Booking";
  }else if (
    hasNewMessageFromParent &&
    currentParentMessge?.from_welldugo_oc &&
    currentParentMessge?.type==="verify-search-link"
  ){
    MiniInforPromptData = currentParentMessge?.postBody;
    PopupTitle="Verify Search Link";
    PopupMsgSource="Operational Center";
    PopupActionFunction = () => {
      if(window.confirm("Are you sure?")){
        setCurrentParentMessge({});
        setHasNewMessageFromParent(false);
        if(localStorage.getItem("verify_search_link")){
          localStorage.removeItem("verify_search_link");
        }
        window.location.reload();
      }
    }
    PopupActionButtonTitle = "Cancel Link Verification";
  }else if(localStorage.getItem("verify_search_link")){
    let __obj = JSON.parse(localStorage.getItem("verify_search_link"));
    MiniInforPromptData = __obj?.postBody;
    PopupTitle="Verify Search Link";
    PopupMsgSource="Operational Center";
    PopupActionFunction = () => {
      if(window.confirm("Are you sure?")){
        setCurrentParentMessge({});
        setHasNewMessageFromParent(false);
        if(localStorage.getItem("verify_search_link")){
          localStorage.removeItem("verify_search_link");
        }
        window.location.reload();
      }
    }
    PopupActionButtonTitle = "Cancel Link Verification";
  }

  return (
    <div>
      {
        (!BESettings?._id) && <div style={{display: "flex", justifyContent: "center", alignItems: "center", padding: 50, backgroundColor: "#eee"}}>
          <p>Please Wait. Loading app settings...</p>
        </div>
      }
      {
        (
          (
            hasNewMessageFromParent &&
            currentParentMessge?.from_welldugo_oc &&
            (
              currentParentMessge?.type==="book-itinerary-item" ||
              currentParentMessge?.type==="verify-search-link" 
            )
          ) ||
          (
            localStorage.getItem("book_itinerary_item") ||
            localStorage.getItem("verify_search_link")
          )
          
        ) &&
        <MiniInfoWindow 
          source={PopupMsgSource}
          title={PopupTitle}
          data={MiniInforPromptData}
          close_function={PopupCloseFunction}
          button_title={PopupActionButtonTitle}
          button_function={PopupActionFunction}
        />
      }
      {
        toggleShowCurrencyPage && <CurrenciesPane
          SelectSiteCurrency={SelectSiteCurrency}
          toggle_show_hide_pane={toggle_show_hide_currency_page} />
      }
      {
        toggleShowLanguagesPage && <LanguagesPane
          SelectSiteLanguage={SelectSiteLanguage}
          toggle_show_hide_pane={toggle_show_hide_languages_page} />
      }
      <HPSupport />
      <MobileMenu />
      {
        (isCheckout && checkoutDataProvider) ?
          <CheckoutPage
            rawData={checkoutRawData}
            data_provider={checkoutDataProvider}
            bookingEngine={BESettings}
            LogMeIn={LogMeIn}
            payload={checkoutPayload}
            cancel_checkout={cancel_checkout}
            paymentIntent={paymentIntent}
            setPaymentIntent={setPaymentIntent}
            bookingIntent={bookingIntent}
            setBookingIntent={setBookingIntent}
            productType={productType}
            change_product_type={change_product_type}
            hasNewMessageFromParent={hasNewMessageFromParent}
            currentParentMessge={currentParentMessge}
          />
        : ""
      }{
        (agentDetails && BESettings?.showHeader) &&
          <Header
            bookingEngine={BESettings}
            agentDetails={agentDetails}
            showSearchPage={showSearchPage}
            show_home_page={show_home_page}
            cancel_checkout={cancel_checkout}
            productType={productType}
            hasNewMessageFromParent={hasNewMessageFromParent}
            currentParentMessge={currentParentMessge}
          />
        }
      <HomePage
        bookingEngine={BESettings}
        agentDetails={agentDetails}
        show_search_page={show_search_page}
        showSearchPage={showSearchPage}
        begin_checkout={begin_checkout}
        showSearchForm={showHomePageSearchForm}
        siteCurrency={siteCurrency}
        siteLanguage={siteLanguage}
        toggle_show_hide_currency_page={toggle_show_hide_currency_page}
        toggle_show_hide_languages_page={toggle_show_hide_languages_page}
        productType={productType}
        change_product_type={change_product_type}
        hasNewMessageFromParent={hasNewMessageFromParent}
        currentParentMessge={currentParentMessge}
        showSearchPageForm={showSearchPageForm}
        setShowSearchPageForm={setShowSearchPageForm}
      />
      <TripsPage />
      <DealsPage
        bookingEngine={BESettings}
        hasNewMessageFromParent={hasNewMessageFromParent}
        currentParentMessge={currentParentMessge}
      />
      <HelpPage />
      <div className='wrapper'  id="login_page" style={{display: "none"}}>
        <LoginPage
          bookingEngine={BESettings}
          LogMeIn={LogMeIn}
          isLoggedIn={isLoggedIn} />
        <UserAccountPage
          bookingEngine={BESettings}
          LogMeOut={LogMeOut}
          isLoggedIn={isLoggedIn} />
      </div>
      <ExplorePage />
      {
        (agentDetails && BESettings?._id) &&
        <Footer
          bookingEngine={BESettings}
          agentDetails={agentDetails}
        />
      }
      <ToastContainer
        className="my-toast-container"
        position="top-left" />
    </div>
  );
}

export default App;
